var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "452.241px",
    viewBox: "0 0 512 452.241",
    enableBackground: "new 0 0 512 452.241",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#202028",
    strokeWidth: 27,
    strokeMiterlimit: 10,
    d: "M152.543,432.295 c-5.704,5.577-14.85,5.476-20.429-0.228l-82.643-84.496c-5.579-5.702-5.478-14.848,0.226-20.427L365.533,18.229 c5.705-5.58,14.851-5.479,20.43,0.225l82.643,84.495c5.58,5.704,5.477,14.85-0.228,20.428L152.543,432.295z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#202028",
    stroke: "#202028",
    strokeWidth: 27,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "45.275,339.733 45.275,436.412 145.685,436.412"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.97c0cbd9.svg";
export { ForwardRef as ReactComponent };